import React from "react";

const VenueView = ({ currentRecord }) => {
  return (
    <div className="overflow-hidden bg-white rounded-lg shadow-lg">
      {/* Header with venue name */}
      <div className="px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-800">
        <h2 className="text-2xl font-bold text-white">
          {currentRecord.venue_name}
        </h2>
      </div>

      {/* Content section */}
      <div className="p-6">
        <div className="mb-6">
          <h3 className="mb-2 text-lg font-semibold text-gray-700">
            Description
          </h3>
          <div className="p-4 border border-gray-200 rounded-md bg-gray-50">
            {currentRecord.description ? (
              <p className="text-gray-700 whitespace-pre-wrap">
                {currentRecord.description}
              </p>
            ) : (
              <p className="italic text-gray-500">No description available</p>
            )}
          </div>
        </div>

        {/* Venue details */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="p-4 border border-gray-200 rounded-md bg-gray-50">
            <h3 className="mb-1 text-sm font-semibold text-gray-600">
              Venue ID
            </h3>
            <p className="text-gray-800">{currentRecord._id || "N/A"}</p>
          </div>

          <div className="p-4 border border-gray-200 rounded-md bg-gray-50">
            <h3 className="mb-1 text-sm font-semibold text-gray-600">
              Church ID
            </h3>
            <p className="text-gray-800">{currentRecord.church_id || "N/A"}</p>
          </div>

          {currentRecord.createdAt && (
            <div className="p-4 border border-gray-200 rounded-md bg-gray-50">
              <h3 className="mb-1 text-sm font-semibold text-gray-600">
                Created On
              </h3>
              <p className="text-gray-800">
                {new Date(currentRecord.createdAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>
          )}

          {currentRecord.updatedAt && (
            <div className="p-4 border border-gray-200 rounded-md bg-gray-50">
              <h3 className="mb-1 text-sm font-semibold text-gray-600">
                Last Updated
              </h3>
              <p className="text-gray-800">
                {new Date(currentRecord.updatedAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Footer section */}
      <div className="px-6 py-3 border-t border-gray-200 bg-gray-50">
        <p className="text-sm text-gray-500">
          Venue information displayed above. For any changes, please use the
          edit function.
        </p>
      </div>
    </div>
  );
};

export default VenueView;
